import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReceitaNivelPrevistoArrecadadoComponent } from './receita-nivel-previsto-arrecadado.component';

const routes: Routes = [
  {
    path: ':ano/:sistema',
    component: ReceitaNivelPrevistoArrecadadoComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReceitaNivelPrevistoArrecadadoRoutingModule { }
